import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { AdjustmentsVerticalIcon } from "@heroicons/react/24/outline";
import { useContext } from "react";
import {
  AutopilotSearchStrategyJobEnum,
  InternalCuratedSearchFilters,
} from "../../../__generated__/graphql";
import classNames from "classnames";
import CuratedInternalSearchFilterCard from "../CuratedSearchFilters/CuratedInternalSearchFilterCard";
import AutopilotCuratedInternalSearchContext, {
  AutopilotCuratedInternalSearchContext_InternalSearchFilters,
} from "../../../contexts/AutopilotCuratedInternalSearchContext";
import CuratedSearchCardHeader from "../CuratedSearchCard/CuratedSearchCardHeader";
import { gql } from "@apollo/client";
import AutopilotCuratedSearchContext from "../../../contexts/AutopilotCuratedSearchContext";

interface ICuratedSearchDesignSelectedStrategyCard {
  showRecommendedBadge?: boolean;
  savedFilters: InternalCuratedSearchFilters;
  setSavedFilters: (value: InternalCuratedSearchFilters | null) => void;
  selectedStrategy: AutopilotSearchStrategyJobEnum | null;
}

export const CuratedSearchDesignSelectedStrategyCard_AutopilotSearchDesignInternalFiltersStep = gql`
  fragment CuratedSearchDesignSelectedStrategyCard_AutopilotSearchDesignInternalFiltersStep on AutopilotSearchDesignInternalFiltersStep {
    jobId
    internalFiltersData {
      filters {
        ...AutopilotCuratedInternalSearchContext_InternalSearchFilters
      }
      totalResultCount
      isBestStrategy
    }
  }

  ${AutopilotCuratedInternalSearchContext_InternalSearchFilters}
`;

const CuratedSearchDesignSelectedStrategyCard = ({
  showRecommendedBadge = false,
  savedFilters,
  setSavedFilters,
  selectedStrategy,
}: ICuratedSearchDesignSelectedStrategyCard) => {
  const { onSaveFilters } = useContext(AutopilotCuratedInternalSearchContext);

  const { scoringCriteriaValues } = useContext(AutopilotCuratedSearchContext);

  // Get the job name from props or derive from jobId
  const getStrategyName = () => {
    if (
      selectedStrategy ===
      AutopilotSearchStrategyJobEnum.IndustryKeywordsStrategy
    )
      return "Industry & Keywords";
    if (
      selectedStrategy ===
      AutopilotSearchStrategyJobEnum.SpecificCompaniesStrategy
    )
      return "Specific Companies";
    return "Selected Search";
  };

  return (
    <div
      className={classNames(
        "mt-8",
        "border",
        "border-gray-200",
        "rounded-md",
        "overflow-hidden",
      )}
    >
      <div className={classNames("p-4", "pb-2")}>
        <CuratedSearchCardHeader
          headerText={`${getStrategyName()} Filters`}
          headerIcon={
            <AdjustmentsVerticalIcon className="h-5 w-5 text-orange-500" />
          }
        />

        {showRecommendedBadge && (
          <div
            className={classNames(
              "mt-4",
              "p-4",
              "bg-orange-50",
              "border",
              "border-orange-200",
              "rounded-md",
              "mb-4",
              "text-sm",
              "text-orange-700",
            )}
          >
            <div className="flex items-center gap-2">
              <CheckCircleIcon className="w-5 h-5 text-orange-600" />
              <p>
                <strong>This search strategy is recommended</strong> based on
                our evaluation of both approaches.
              </p>
            </div>
          </div>
        )}
      </div>

      <div className="px-4 pb-4">
        <CuratedInternalSearchFilterCard
          onSave={async () => {
            await onSaveFilters({
              currentFilters: savedFilters,
              scoringCriteriaValues,
            });
          }}
          curatedSearchId={null}
          scoringCriteriaValues={scoringCriteriaValues}
          hideHeader={true}
          savedFilters={savedFilters}
          setSavedFilters={setSavedFilters}
        />
      </div>
    </div>
  );
};

export default CuratedSearchDesignSelectedStrategyCard;
